export default "__VITE_ASSET__BEKJTkfN__"